import React from 'react';
import { Container } from '@dev/ee-components';
import { useSelector } from 'react-redux';

import { getConfigStore } from '@/store/config/types';
import { HistoryBackActionContext, useHistoryBackAction } from '@/services/hooks/useHistoryBackAction';

import { StartCampaignCreator } from '@/components/CampaignCreator/Start';
import { getCampaignsStore } from '@/store/campaigns/actions';
import { ScreenContainer } from './components/StyledComponents';
import { ContactListTable } from './components/ContactListTable';
import { ContactsListHeader } from './components/ContactsListHeader';

export const ListOfContacts = (): JSX.Element => {
    const { isStandalone } = useSelector(getConfigStore);
    const { isCampaignCreatorOpen } = useSelector(getCampaignsStore);
    const Wrapper = isStandalone ? Container : ScreenContainer;

    const isSavedRef = React.useRef(true);
 
    const historyBackAction = useHistoryBackAction({
        isSavedRef
    });
    
    return (
        <Wrapper>
            <HistoryBackActionContext.Provider value={historyBackAction}>
                <ContactsListHeader />
                <ContactListTable />
                {isCampaignCreatorOpen && <StartCampaignCreator />}
            </HistoryBackActionContext.Provider>
        </Wrapper>
    );
};
